__turbopack_context__.v({
  "arrow": "ArchiveItemPreview-module-scss-module__wA6ujW__arrow",
  "card": "ArchiveItemPreview-module-scss-module__wA6ujW__card",
  "categoryTilePngBgImg": "ArchiveItemPreview-module-scss-module__wA6ujW__categoryTilePngBgImg",
  "content": "ArchiveItemPreview-module-scss-module__wA6ujW__content",
  "excerpt": "ArchiveItemPreview-module-scss-module__wA6ujW__excerpt",
  "imageAndNavWrapper": "ArchiveItemPreview-module-scss-module__wA6ujW__imageAndNavWrapper",
  "imageMode": "ArchiveItemPreview-module-scss-module__wA6ujW__imageMode",
  "imageWrapper": "ArchiveItemPreview-module-scss-module__wA6ujW__imageWrapper",
  "navButton": "ArchiveItemPreview-module-scss-module__wA6ujW__navButton",
  "navButtonPrev": "ArchiveItemPreview-module-scss-module__wA6ujW__navButtonPrev",
  "noSvgPlaceholder": "ArchiveItemPreview-module-scss-module__wA6ujW__noSvgPlaceholder",
  "nonClickable": "ArchiveItemPreview-module-scss-module__wA6ujW__nonClickable",
  "patternBgWrapper": "ArchiveItemPreview-module-scss-module__wA6ujW__patternBgWrapper",
  "patternOverlay": "ArchiveItemPreview-module-scss-module__wA6ujW__patternOverlay",
  "patternOverlayImg": "ArchiveItemPreview-module-scss-module__wA6ujW__patternOverlayImg",
  "readMore": "ArchiveItemPreview-module-scss-module__wA6ujW__readMore",
  "svgImage": "ArchiveItemPreview-module-scss-module__wA6ujW__svgImage",
  "svgMode": "ArchiveItemPreview-module-scss-module__wA6ujW__svgMode",
  "tag": "ArchiveItemPreview-module-scss-module__wA6ujW__tag",
  "tags": "ArchiveItemPreview-module-scss-module__wA6ujW__tags",
  "title": "ArchiveItemPreview-module-scss-module__wA6ujW__title",
  "variantCounter": "ArchiveItemPreview-module-scss-module__wA6ujW__variantCounter",
  "variantNavigation": "ArchiveItemPreview-module-scss-module__wA6ujW__variantNavigation",
});
